import { useState } from 'react';

/**
 * True during the render in which `value` differs from the previous render's, so callers can
 * adjust their own state while rendering instead of in an effect (react.dev: "Adjusting some
 * state when a prop changes"). `initial` is the value the first render is compared against.
 */
export function useHasChanged<T>(value: T, initial: T = value): boolean {
  const [prev, setPrev] = useState(initial);
  if (Object.is(prev, value)) return false;
  setPrev(value);
  return true;
}
